<template>
  <div class="MemberMyConsultation">
    <el-tabs class="el-tabs-common" v-model="current">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.label + '(' + myConsultTotal[index] + ')'"
      ></el-tab-pane>
    </el-tabs>
    <ConsultUpvoteStatus
      :list="list"
      :isData="isData"
      :page="page"
      :limit="limit"
      :total="total"
      getPage="MemberMyConsultation"
    ></ConsultUpvoteStatus>
  </div>
</template>
<script>
import ConsultUpvoteStatus from "@/components/ConsultUpvoteStatus.vue";

export default {
  name: "MemberMyConsultation",
  components: { ConsultUpvoteStatus },
  data() {
    return {
      current: "0",
      list: [],
      limit: 10,
      page: 1,
      total: 0,
      isData: 1,
      myConsultTotal: [0, 0, 0],
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    types() {
      let types = [
        {
          type: "0",
          label: "全部",
        },
        {
          type: "2",
          label: "已回复",
        },
        {
          type: "1",
          label: "待回复",
        },
      ];
      return types;
    },
  },
  watch: {
    async current() {
      this.page = 1;
      await this.getData();
    },
  },
  async created() {
    await this.getData();
  },
  methods: {
    //点赞
    async handleZan(item) {
      await this.$http.get(`/api/app/teacher/consult/upvoteStatus`, {
        id: item.id,
      });
      this.$message({
        message: item.is_upvote == 0 ? "点赞成功！" : "取消点赞成功！",
        type: "success",
      });
      await this.getData();
    },
    async delConsult(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete(`/api/app/teacher/consult/userDelete/` + item.id);
      this.page = 1;
      await this.getData();
    },
    async getData() {
      let myConsultTotal = await this.$http.get("/api/app/user/myConsultTotal");
      this.myConsultTotal = [
        myConsultTotal.all_recover_num,
        myConsultTotal.recover_num,
        myConsultTotal.not_recover_num,
      ];
      let data = await this.$http.get("/api/app/user/myConsult", {
        is_recover: this.current,
        limit: this.limit,
        page: this.page,
      });
      data.data.forEach(item => {
        if (item.recover_info && item.recover_info.image) {
          item.recover_info.image = item.recover_info.image.split(",");
        }
      });
      this.list = data.data;
      if (data.data && data.data.length > 0) {
        this.isData = 1;
      } else {
        this.isData = 0;
      }
      this.total = data.total;
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.MemberMyConsultation {
  background: #fff;
  padding: 0 24px;
  width: 100%;
  float: left;
  min-height: 400px;
  box-sizing: border-box;
}
.el-tabs-common {
  padding: 2px 0 0 0;
  width: 100%;
  float: left;
  box-sizing: border-box;
}

.tab-content {
  padding: 12px 0 24px 0;
  background-color: white;
}
.TeacherAdminIndex {
  padding: 0px;
  /deep/ {
    .main_left {
      padding-left: 0px;
    }
  }
}
</style>
